<template>
  <div id="help-lgpd">
    <VuePerfectScrollbar class="attendance-scroll-area" :settings="settings">
      <div class="content-lgpd">
        <h1>{{ $t("HELP_LGPD").LGPD_Title }}</h1> 
        <div>
          <span class="texto-cma">{{ $t("HELP_LGPD").LGPD_Text }}</span>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import themeConfig from "../../../../themeConfig";
import AppConstants from "../../../appConstants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {},
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.5
        },
    };
  },
  computed: {
    isSafrasPlatform() {
      return themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS;
    },
  },
};
</script>

<style lang="scss">
#help-lgpd {
  img {
    width: 100px;
    float: left;
    margin-right: 15px;
  }
}

.content-lgpd img {
  padding-left: 13px;
  padding-top: 15px;
}

.content-lgpd {
  font-size: 12px;
  line-height: 20px;
  margin-top: 11px;
}
</style>